/* "En espera" = programados + pospuestos.
   Son la misma idea —correo que aún no toca— y comparten vista con pestañas,
   así que en la barra lateral ocupan UNA sola entrada. Esto recuerda en qué
   pestaña estabas para que el botón abra donde la dejaste. */
const CLAVE = 'zuno_transito';

export const TRANSITO_IDS = ['scheduled', 'snoozed'];

export const esTransito = (id) => TRANSITO_IDS.includes(id);

export function recordarTransito(id) {
  if (!esTransito(id)) return;
  try { localStorage.setItem(CLAVE, id); } catch (_) {}
}

/** Dónde abrir "En espera": la última pestaña usada; si esa está vacía y la
 *  otra tiene algo, abre donde hay correo (caer en una lista vacía teniendo
 *  cosas al lado se lee como un error). */
export function destinoTransito({ programados = 0, pospuestos = 0 } = {}) {
  let ultima = null;
  try { ultima = localStorage.getItem(CLAVE); } catch (_) {}
  if (!esTransito(ultima)) ultima = 'snoozed';
  const cuantos = (id) => (id === 'scheduled' ? programados : pospuestos);
  if (cuantos(ultima) === 0) {
    const otra = ultima === 'scheduled' ? 'snoozed' : 'scheduled';
    if (cuantos(otra) > 0) return otra;
  }
  return ultima;
}
